module.exports = __webpack_public_path__ + "img/quard10.bfb91ad5.png";